import {
  FaMoneyBill,
  FaPiggyBank,
  FaShareAltSquare,
  FaStore,
  FaStripe,
} from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import styles from "./StoreGuide.module.css";
import globalStyles from "../../styles/globalStyles.module.css";
import { useTranslation } from "react-i18next";

const StoreGuide: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={`${styles.container}`}>
      <div className={globalStyles.pageTitle}>{t("store.guide.title")}</div>
      <div className={`${styles.guideSection}`}>
        <h3>{t("store.guide.step1")}</h3>
        <div className={styles.section}>
          <p className={styles.guideTextSection}>
            <strong>Importez vos images</strong> pour créer des cartes à l'aide
            de l'interface intégrée
          </p>
          <img
            src="/images/guide/card.webp"
            alt="Create a card"
            className={styles.guideImageSection}
          />
        </div>
      </div>
      <div className={`${styles.guideSection}`}>
        <div className={styles.section}>
          <img
            src="/images/guide/booster.webp"
            alt="Create a card"
            className={styles.guideImageSection}
          />
          <p className={styles.guideTextSection}>
            Regrouper vos cartes pour <strong>construire une collection</strong>
          </p>
        </div>
      </div>
      <div className={`${styles.guideSection}`}>
        <h3>{t("store.guide.step2")}</h3>
        <div className={styles.section}>
          <p className={styles.guideTextSection}>
            Indiquez le prix souhaité et{" "}
            <strong>ajoutez votre booster à votre boutique</strong>
          </p>
          <div className={styles.boosterPrice}>
            <div className={styles.storeIcon}>
              <FaStore size={50} />
            </div>
            <img
              src="/images/guide/booster.webp"
              alt="Create a card"
              className={`${styles.guideImageSection} ${styles.disable}`}
            />
            <strong>10€</strong>
          </div>
        </div>
      </div>
      <div className={`${styles.guideSection}`}>
        <div className={styles.section}>
          <FaShareAltSquare size={80} />
          <div className={styles.guideTextSection}>
            <strong>Partagez</strong> le lien de votre boutique sur les réseaux
            sociaux
          </div>
        </div>
      </div>
      <div className={`${styles.guideSection}`}>
        <h3>{t("store.guide.step3")}</h3>
        <p>
          Les achats complétés peuvent être{" "}
          <strong>transférés sur votre compte bancaire</strong> quand vous le
          souhaitez
        </p>
        <div className={styles.transferSection}>
          <FaStripe size={80} />
          <div className={styles.flex}>
            <FaMoneyBill size={50} />
            <FaArrowRightLong size={80} />
          </div>
          <FaPiggyBank size={80} />
        </div>
      </div>
    </div>
  );
};

export default StoreGuide;
